import type { SharedTimeZone, TimeZonePreferenceResult } from '@/types/serializers'
import { type HttpIo, requestJson } from './http.ts'

export interface TimeZoneInferenceIo {
  url: string
  detect: () => string | null
  reload: () => void
  onceRouterReady: (callback: () => void) => void
  http?: HttpIo
}

export function initTimeZoneInference(
  timeZone: Pick<SharedTimeZone, 'source'>,
  io: TimeZoneInferenceIo,
): void {
  if (timeZone.source !== 'default') return

  const detected = io.detect()
  if (!detected) return

  const ready = new Promise<void>((resolve) => io.onceRouterReady(resolve))
  const answered = requestJson<TimeZonePreferenceResult>(
    io.url,
    { method: 'PATCH', body: { time_zone: detected, inferred: true } },
    io.http,
  )
  Promise.all([ready, answered]).then(([, result]) => {
    if (result.ok && result.data.changed) io.reload()
  })
}
